import { useEffect, useState } from 'react';
import { getCacheStats } from '../utils/audioCache';

/**
 * useCacheStats
 *
 * Encapsula el estado del contador de caché offline (peso + número de audios)
 * y refresca cada 30 s. Extraído de `App.js` (feb-2026) — antes vivía como
 * un `useEffect` inline dentro de `AuthenticatedApp`.
 *
 * Devuelve además `refreshCacheStats` para forzar un refresh puntual (p.ej.
 * después de descargar/limpiar la caché de un evento sin esperar al polling).
 */
export function useCacheStats(pollingIntervalMs = 30_000) {
  const [cacheStats, setCacheStats] = useState({ totalCount: 0, totalSizeMB: '0' });

  const refreshCacheStats = async () => {
    const stats = await getCacheStats();
    setCacheStats(stats);
  };

  useEffect(() => {
    refreshCacheStats();
    const interval = setInterval(refreshCacheStats, pollingIntervalMs);
    return () => clearInterval(interval);
  }, [pollingIntervalMs]);

  return { cacheStats, setCacheStats, refreshCacheStats };
}
